function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNorwayFlagCircular = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "none",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#ef2b2d",
    fillRule: "nonzero",
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.25.168a44.74 44.74 0 0 0-22.5 8.293v25.29H1.418C.492 37.346 0 41.115 0 45s.492 7.654 1.418 11.25H18.75v25.29a44.74 44.74 0 0 0 22.5 8.293V56.25h47.332C89.508 52.654 90 48.885 90 45s-.492-7.654-1.418-11.25H41.25z",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#f3f4f5",
    fillRule: "nonzero",
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.625.985a44.7 44.7 0 0 0-11.25 4.024v34.366H.362C.132 41.219 0 43.094 0 45s.132 3.781.362 5.625h24.013v34.366a44.7 44.7 0 0 0 11.25 4.024v-38.39h54.013c.23-1.844.362-3.719.362-5.625s-.132-3.781-.362-5.625H35.625z",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#002868",
    fillRule: "nonzero",
    opacity: 1
  }
})));
export default SvgNorwayFlagCircular;